<div class="w-100 h-100 d-flex align-items-center justify-content-center"
    [style.background-color]="text | cwtInitials: length | textColor: 60">
    <span [style.color]="text | cwtInitials: length | textColor: 20">
        {{text | cwtInitials: length | uppercase}}
    </span>
</div>